import { render, staticRenderFns } from "./Form133_v2.vue?vue&type=template&id=0641b58a&scoped=true&"
import script from "./Form133_v2.vue?vue&type=script&lang=js&"
export * from "./Form133_v2.vue?vue&type=script&lang=js&"
import style0 from "./Form133_v2.vue?vue&type=style&index=0&id=0641b58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0641b58a",
  null
  
)

export default component.exports